import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { makeSelectCriteriaUsage } from "entities/alg_criteriaUsage/selectors";
import { makeSelectMetaSKill } from "entities/alg_metaSkills/selectors";
import { makeSelectPrinciple } from "entities/alg_principles/selectors";
import { makeSelectEntityStatuses } from "entities/entity_status/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";

const selectEntity = state => state.entities.alg_criteria;
const selectEntityData = state =>
  state.entities.alg_criteria ? state.entities.alg_criteria.data : {};

export const makeSelectCriteria = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectCriteriaUsage(),
      makeSelectMetaSKill(),
      makeSelectPrinciple(),
      makeSelectEntityStatuses(),
      makeSelectStringSource(),
      makeSelectTranslation()
    ],
    (
      substate,
      page,
      criteriaUsage,
      metaSkill,
      principle,
      statuses,
      resources,
      translations
    ) => {
      if (!paginationKey) {
        const state = { ...substate };

        return state;
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            const criteria = { ...substate[id] };
            criteria.meta_skill = metaSkill[criteria.meta_skill.id];
            criteria.criteria_usage = criteriaUsage[criteria.criteria_usage.id];
            criteria.principle = principle[criteria.principle.id];
            criteria.entity_status = statuses[criteria.entity_status.id];

            for (let string of resources) {
              if (string.id === criteria.name)
                criteria.string_resources = string;
            }
            const newTranslations = [];
            for (let translation of criteria.string_resources.translations) {
              newTranslations.push(translations[translation.id]);
            }
            criteria.string_resources.translations = newTranslations;

            return criteria;
          })
          .filter(row => row);
    }
  );

export const makeSelectCriteriaLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });

export const makeSelectCriteriaError = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.error;
  });
